import React from "react";
import { useNavigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { envConfig } from "../utils/envConfig";

export default function Auth0ProviderWithNavigate({ children }) {
  const navigate = useNavigate();
  const domain = envConfig.authDomain;
  const clientId = envConfig.authClientId;
  const audience = envConfig.authAudience;
  const redirect_uri = window.location.origin;
  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || "/");
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience,
        scope: "openid profile email",
        redirect_uri: redirect_uri,
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      useRefreshTokensFallback={true}
    >
      {children}
    </Auth0Provider>
  );
}
